export const Email_VALIDATOR = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
export const NAME_VALIDATOR = /^([^0-9]*)$/g;
export const URL_VALIDATOR = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g


export const ERRORS = {
    IN_VALID_EMAIL: '* Please enter a valid email id',
    EMAIL_REQUIRED: '* Email id is required',
    COUPON_REQUIRED: '* Coupon code is required',
    PASSWORD_REQUIRED: '* Password is required',
    PASSWORD_LENGTH: '* Password too short. The password should contain minimum of 8 characters.',
    PASSWORD_MAX_LENGTH: '* Password too long. The password should contain maximum of 30 characters.',
    NAME_REQUIRED: '* Username is required',
    NAME_MAX_LENGTH: '* Name too long. The name should contain maximum of 30 characters',
    IN_VALID_NAME: '* Please enter a valid name',
    PASSWORD_MATCH_ERROR: '* Password does not match!',
    WEBSITE_TITLE_REQUIRED: '* Title is required',
    WEBSITE_TITLE_MAX_LENGTH: '* Website Title too long. The Website Title should contain maximum of 150 characters.',
    CTA_TITLE_MAX_LENGTH: '* CTA Title too long. The Website Title should contain maximum of 20 characters.',
    WEBSITE_CAMPAIGN_TITLE_MAX_LENGTH: '* Campaign Title too long. The Campaign Title should contain maximum of 30 characters.',
    WEBSITE_MESSAGE_MAX_LENGTH: '* Message too long. The Message above 120 characters may not appear in some browsers.',
    WEBSITE_URL_REQUIRED: '* URL is required',
    WEBSITE_URL_VALID: '* Please enter a valid URL',
    WEBSITE_HTTPS_REQUIRED: '* Please enter a valid Website URL starting with "https://"',
    IN_VALID_PHONE_NUMBER:'* Please enter a valid phone number',
    PHONE_NUMBER_REQUIRED: '* Phone number is required',
    // WEBSITE_URL_REQUIRED: '* Website url is required',
    // WEBSITE_URL_VALID: '* Please enter a valid URL',
    WEBSITE_LOGO_REQUIRED: '* Website logo is required',
    SEGMENT_NAME_REQUIRED: '* Segment Name is required',
    SEGMENT_NAME_MAX_LENGTH: '* Segment Name too long. The name should contain maximum of 50 characters',
    TOPIC_REQUIRED:  '* Topic is required',
    TOPIC_MAX_LENGTH: '* Topic too long. The Topic should contain maximum of 12 characters.',
    email_not_verified: 'Your email is not verified yet. Click here to get the activation link sent to your registered Email ID.',
    email_not_exist: 'Invalid email! This email address does not exist in our records. Please try another email or consider signing up.',
    incorrect_authentication_credentials: 'Invalid password, Please try again',
    account_locked: 'Your account has been locked due to multiple login failure attempts. Please reset password to login.',
    email_already_exist: 'An account with this email already exists.',
    website_already_exist: 'This website is already taken. Please contact support@chirpyweb.com to claim access to this website.',
    height_and_width_must_be_between_minimum_192px_to_maximum_512px: 'Minimum size for logo is required 192x512.',
    must_be_png_jpg_or_jpeg_format: 'Invalid format. Upload logo of .png, .jpg or .jpeg. extension',
    maximum_active_topics_limit_6: 'You can only activate 6 topics',
    topic_exists: 'Topic name already exists, please choose a unique name.',
    name_exists: 'Topic name already exists',
    minimum_one_website_required: 'Minimum one website is required',
    TITLE_REQUIRED: '* Title is required',
    MESSAGE_REQUIRED: '* Message is required',
    WELCOME_LINK_REQUIRED: '* Welcome Link is required',
    LANDING_PAGE_URL_REQUIRED: '* Landing Page Url is required',
    SCHEDULE_AT_TILE_REQUIRED: '* Schedule At Time is required',
    INVALID_SCHEDULE_AT_TILE_REQUIRED: '* Please enter a valid numeric value',
    INVALID_SCHEDULE_AT: '* Please enter a valid numeric value',
    NAME_LENGTH:'* Name too long. The name should contain maximum of 40 characters.',
    EMAIL_LENGTH:'* Email too long. The email should contain maximum of 255 characters.',
    OLD_TIME: '* Please select time at least 10 minutes later than current time.',
    PREVIOUS_PASSWORD: 'You cannot use your previous password',
    SEGMENT_ERRORS: {
        name_exists: 'Segment Name already exists. Please choose another name.',
    },
    PERMISSION_PROMPT_ERRORS : {
        TITLE_REQUIRED: '* Title is required',
        MESSAGE_REQUIRED: '* Message is required',
        ALLOW_TEXT_REQUIRED: '* Allow Button text required',
        DENY_TEXT_REQUIRED: '* Later Button text required',
        ICON_REQUIRED: '* Icon is required',
        STICKY_TEXT_REQUIRED: '* Sticky Text is required',
    },
    website_exhausted: 'You have crossed your website limit, Please upgrade your plan to add more websites',
    drip_notification_not_exists: 'Please setup drip notification to enable',
    rss_feed_not_exists: 'Please setup rss feed to enable',
    url_exists: 'The feed url entered already exists',
    page_not_found:'The feed url entered not found',
    user_exists: 'The user is already added',
    reached_your_limit: 'Your account has been suspended and can no longer send push notifications as the Free Plan has crossed its limit. Kindly upgrade to continue sending push notifications.',
    payment_failed: 'Your account has been suspended due to payment failure and can no longer send push notifications. Kindly upgrade to continue sending push notifications.', 
    subscription_cancelled: 'Your account is suspended and can no longer send push notifications. Kindly upgrade to continue sending push notifications.',
    BUTTON_TEXT_REQUIRED: '* Button text is required',
    ECOM_SUCCESSS_REQUIRED: '* Success message is required',
    ECOM_NOTIFICATION_AFTER_ERROR: '* Notification sent after should not be less than 1',
    sw_path: 'No Service worker linked',
    shopify_not_enabled: 'This website has not enabled shopify',
    coupon_not_valid: 'Invalid Coupon Code or Code Already Redeemed',
    token_expired: 'Your token has expired, Please try logging in again',
    INVALID_KEY: 'Please enter a valid key',
    MISSING_KEY: '* Key is required',
}


export const ALERT_MESSAGES= {
    DELETE_WEBSITE: 'Are you sure you want to delete this website?',
}


export const SEGMENT_FILTERS_LIST = [
    {
        name: 'Platform',
        value: 'platform',
        operator: ['equal', 'not equal'],
        values : []
    },
    {
        name: 'Browser',
        value: 'browser',
        type: 'list',
        operator: ['equal', 'not equal'],
        values: [],
    },
    {
        name: 'Geo Location',
        value: 'country_iso',
        type: 'list',
        operator: ['equal', 'not equal'],
        values: [],
    }, 
    {
        name: 'Subscription Date',
        value: 'first_seen',
        type: 'date',
        operator: [
            'before',
            'after',
            'on',
            'between'
        ],
        values: [],
    },
    {
        name: 'Last Website Visit',
        value: 'last_seen',
        type: 'date',
        operator: [
            'before',
            'after',
            'on',
            'between'
        ],
        values: [],
    },
];


export const SEGMENT_OPERATORS = {
    list: ['equal', 'not equal'],
    date: [
        'before',
        'after',
        'on',
        'between'
    ],
}  

export const TERMS_URL = 'https://chirpyweb.com/terms-conditions/';
export const PRIVACY_URL = 'https://chirpyweb.com/privacy-policy/';

export const BASIC_PLAN = () => <>Available with the Premium Plan(only <strong>$14/month</strong>)</>;

export const PAID_DESCRIPTION = {
    segmentation: 'Separate the subscribers into different groups based on their actions and properties such as location, subscription date, URL visited, etc.',
    topic: 'Let the subscribers choose their favorite Topics while signing up for notifications and separate them into predefined Topic groups.',
    'user-management': 'Grant website access to multiple users which different roles such as View, Edit and Send.',
    'drip-notification': 'Drip Notifications is available on the Premium Plan.',
    'rss-feeed': 'RSS Feed is available on the Premium Plan.',
    'woocommerce': 'Woo Commerce is available on premium plan',
    // Abandoned Cart Recovery is available on the Premium Plan
    // Back In Stock Alerts is available on the Premium Plan
    // Price Drop Alerts is available on the Premium Plan
    // Shipping Notifications is is available on the Premium Plan
}

